import { render, staticRenderFns } from "./DrCoordenador.vue?vue&type=template&id=4be19e6a&"
import script from "./DrCoordenador.vue?vue&type=script&lang=js&"
export * from "./DrCoordenador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports